module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/footers/footer-view/footer-view.component.scss
// module id = ./src/app/footers/footer-view/footer-view.component.scss
// module chunks = main